import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  faBoxOpen,
  faTimelineArrow,
  faTruckFast,
  faUserGroup,
  faUserTag,
  faWarehouseFull,
} from '@fortawesome/pro-light-svg-icons';

export interface ReadOnlyApp {
  icon: IconProp;
  title: string;
  routes: ReadOnlyAppRoute[];
  docLinkUrl: string;
  tryOutRoute: string;
}

export interface ReadOnlyAppRoute {
  method: string;
  name: string;
  uri: string;
}

const entities = {
  vehicle: 'vehicles:1a4896b2-ee96-47f2-9c42-c8cc9fe751e3',
  facility: 'facilities:99d97c9c-2ccd-5e2f-b8df-01d2abb64699',
  user: 'e4c1a9b3-cd79-4292-bbfd-cff882cb27ff',
  entity: 'vehicles:9703f25f-c112-54fa-8dca-b27c19b08e03',
  container: 'bag:03ef40a7-844f-5aaf-aebe-dc013ef007db',
  participant: 'vehicles',
  workflow: 'workflow:7acf3e39-cb70-5b06-903d-3319a3a5765a',
  order: 'orders:158c9370-bda4-5714-b67a-c4228e767846',
};

const currentAppList: ReadOnlyApp[] = [
  {
    icon: faTruckFast,
    title: 'Vehicles',
    routes: [
      {
        method: 'GET',
        name: 'vehicle',
        uri: `/app/fpa/api/v1/vehicles/${entities.vehicle}`,
      },
      {
        method: 'GET',
        name: 'vehicle list',
        uri: '/app/fpa/api/v1/vehicles',
      },
    ],
    docLinkUrl: 'https://docs.getos1.com/vehicle-api',
    tryOutRoute: 'vehicles',
  },
  {
    icon: faWarehouseFull,
    title: 'Facilities',
    routes: [
      {
        method: 'GET',
        name: 'facility',
        uri: `/app/fpa/api/v1/facilities/${entities.facility}`,
      },
      {
        method: 'GET',
        name: 'facility list',
        uri: '/app/fpa/api/v1/facilities',
      },
    ],
    docLinkUrl: 'https://docs.getos1.com/facility-api',
    tryOutRoute: 'facilities',
  },
  {
    icon: faUserGroup,
    title: 'Users',
    routes: [
      {
        method: 'GET',
        name: 'user',
        uri: `/app/fpa/api/v1/users/${entities.user}`,
      },
      {
        method: 'GET',
        name: 'user list',
        uri: '/app/fpa/api/v1/users',
      },
    ],
    docLinkUrl: 'https://docs.getos1.com/user-api',
    tryOutRoute: 'users',
  },

  {
    icon: faUserGroup,
    title: 'Entities',
    routes: [
      {
        method: 'GET',
        name: 'entity',
        uri: `/core/api/v2/entity/apps/platform:app:solutions-qa/vehicles/${entities.entity}`,
      },
      {
        method: 'GET',
        name: 'entities list',
        uri: '/core/api/v1/entity-service/apps/platform:app:solutions-qa/vehicles/',
      },
    ],
    docLinkUrl: 'https://docs.getos1.com/entity',
    tryOutRoute: 'entity-service',
  },
  {
    icon: faBoxOpen,
    title: 'Containers',
    routes: [
      {
        method: 'GET',
        name: 'container',
        uri: `/core/api/v2/containers/${entities.container}`,
      },
      {
        method: 'GET',
        name: 'containers list',
        uri: '/core/api/v2/containers/bag/filter',
      },
    ],
    docLinkUrl: 'https://docs.getos1.com/container',
    tryOutRoute: 'containers',
  },
  {
    icon: faUserTag,
    title: 'Participants',
    routes: [
      {
        method: 'GET',
        name: 'participants list',
        uri: `/core/api/v2/participants/${entities.participant}`,
      },
    ],
    docLinkUrl: 'https://docs.getos1.com/participant',
    tryOutRoute: 'participants',
  },

  {
    icon: faTimelineArrow,
    title: 'Workflow',
    routes: [
      {
        method: 'GET',
        name: 'workflow',
        uri: `/core/api/v1/workflow-service/workflows/${entities.workflow}`,
      },
    ],
    docLinkUrl: 'https://docs.getos1.com/workflow',
    tryOutRoute: 'workflows',
  },
  /*
  {
    icon: faBagShopping,
    title: 'Orders',
    routes: [
      {
        method: 'GET',
        name: 'order',
        uri: `/core/api/v1/orders/${entities.order}`,
      },
    ],
    docLinkUrl: 'https://docs.getos1.com/reference/createorder',
    tryOutRoute: 'orders',
  },
  */
];

export const getReadOnlyApps = async (): Promise<ReadOnlyApp[]> => {
  return currentAppList;
};

export const getReadOnlyApp = async (
  tryOutRoute: string
): Promise<ReadOnlyApp | undefined> => {
  return currentAppList.find((app) => app.tryOutRoute === tryOutRoute);
};
